<template>
	<div class="page-in">
	<van-nav-bar
	  :title="$t('我的优惠券')"
	  fixed
	  placeholder
	  left-arrow
	  z-index="99"
	  @click-left="back"
	  :border="false"
	  v-if="isMobileFlag"
	/>
	<div class="inside-page">
		<!-- 手机 -->
		<div class="m-container" v-if="isMobileFlag">
			<div class="m-coupon-card">
				<div class="coupon-input">
					<el-input v-model="form.code" :placeholder="$t('兑换码')"></el-input>
				</div>
				<el-button round  @click="exChange">{{$t('兑换')}}</el-button>
			</div>
			<div class="ucenter-cell">
				<div class="ucenter-content-hd"><span class="tt">{{$t('优惠券列表')}}</span></div>
				<div class="coupons">
					<div class="coupon-card" v-if="tableData && tableData.length > 0" v-for="(item,index) in tableData" :key="index">
						<div class="coupon-left">
							<div class="coupon-icon">
								<img src="@/assets/images/coupon.png" alt="" />
							</div>
						</div>
						<div class="coupon-right">
							<div class="coupon-content">
								<div class="title">{{item.goods}}</div>
								<div class="item">{{$t('使用期限')}}：{{ item.end_time ? item.end_time : $t('永久') }}</div>
								<div class="item">{{$t('减免金额')}}：{{formatNumber(item.reduce)}} {{$t('VND')}}</div>
								<div class="item">{{$t('使用说明')}}：{{item.explain}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- pc -->
		<div class="layui-container" v-else>
			<div class="ucenter">
				<div class="uc-breadcrumb" >
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
					</el-link>	
				</div>
				<UserPanel></UserPanel>
				<div class="ucenter-ht"></div>
				<div class="ucenter-content">
					<div class="ucenter-cell">
						<div class="ucenter-content-hd"><span class="tt">{{$t('兑换抵扣券')}}</span></div>
						<div class="ucenter-filter" >
							<el-form ref="form" :model="form" label-width="80px">
								<el-row :gutter="20">
									<el-col :span="18">
										<el-form-item :label="$t('兑换码') ">
											<el-input v-model="form.code" :placeholder="$t('兑换码')"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4">
										<el-button round type="primary" @click="exChange">{{$t('兑换') }}</el-button>
									</el-col>
								</el-row>	
							</el-form>
						</div>
					</div>
					<div class="ucenter-cell" v-if="tableData && tableData.length > 0">
						<div class="ucenter-content-hd"><span class="tt">{{$t('优惠券列表')}}</span></div>
						<div class="coupons">
							<el-row :gutter="20">
								<el-col :span="10"  v-for="(item,index) in tableData" :key="index">
									<div class="coupon-card">
										<div class="coupon-left">
											<div class="coupon-icon">
												<img src="@/assets/images/coupon.png" alt="" />
											</div>
										</div>
										<div class="coupon-right">
											<div class="coupon-content">
												<div class="title">{{item.goods}}</div>
												<div class="item">{{$t('使用期限')}}：{{ item.end_time ? item.end_time : $t('永久') }}</div>
												<div class="item">{{$t('减免金额')}}：{{formatNumber(item.reduce)}} {{$t('VND')}}</div>
												<div class="item">{{$t('使用说明')}}：{{item.explain}}</div>
											</div>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
	</div>
</template>
<script>
	import UserPanel from './components/UserPanel'
	import {coupons_index_api,coupons_exchange_api} from "@/api/user"
	export default {
		components:{
			UserPanel
		},
		data() {
			return {
				form: {
					code: '',
				},
				currentPage: 1,
				listPage: 1,
				listLimit: 10,
				listTotal: 0,
				tableData: null
			};
		},
		methods:{
			async exChange(){
				if (this.form.code == "") {
					this.errorTips("请输入兑换码");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				let param = {
					code : this.form.code
				};
				const res = await coupons_exchange_api(param);
				if (res && res.data.code == 1) {
					loading.close();
					this.getcouponsData()
					this.form.code = ""
					this.successTips(res.data.msg)
				}else{
					this.form.code = ""
					this.errorTips(res.data.msg)
					loading.close();
				}
			},
			async getcouponsData() {
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				try {
					let param = {
						page: this.listPage,
						limit: this.listPage == 1 ? 10 : this.listLimit,
					};
					const res = await coupons_index_api(param);
					if (res && res.data.code == 1) {
						this.tableData = res.data.data.list
						this.listTotal = res.data.data.total
						loading.close();
					}else{
						loading.close();
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
		},
		mounted() {
			this.getcouponsData()
		}
	}
</script>
<style scoped>
	.uc-breadcrumb{
		margin-bottom: 15px;
	}
	.ucenter-ht{
		height: 20px;
	}
	
	.ucenter-filter .el-button{
		width: 110px;
	}
	.m-coupon-card{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 140px;
		background: url(../../assets/images/coupon-card@2x.png) no-repeat;
		background-size: 100% 100%;
		margin-bottom: 20px;
	}
	.m-coupon-card ::v-deep .el-input__inner{
		border: 0;
		border-radius: 6px;
		text-align: center;
		color: #ffffff;
		background-color: #673c12;
	}
	.coupon-input{
		padding: 20px 20% 10px 20%;
	}
	.m-coupon-card .el-button{
		width: 100px;
		border: 0;
		padding: 10px;
	}
	
	@media (max-width:992px) {
		.coupon-content .item{
			font-size: 12px;
		}
		.coupon-card .coupon-left{
			width: 90px;
		}
		.coupon-left .coupon-icon{
			height: 108px;
		}
		.coupon-content{
			padding: 10px;
		}
		.ucenter-cell .ucenter-content-hd{
			margin-bottom: 10px;
		}
	}
	
	
	
	
	
	
	
</style>
